import { InjectionToken } from "@angular/core";
import { IWidgetRestClient } from "./i-widget-rest.client";

export const widgetRestClientInjectionToken: InjectionToken<IWidgetRestClient> = new InjectionToken<IWidgetRestClient>("digital-signage.developer-dashboard.dashboard-web.WidgetRestClient");
